module.exports = __webpack_public_path__ + "img/left_img3_原_备份.702c74ec.png";